

window.Accordion = {
  $container: null,
  $links: [],
  init: (target) => {
    this.$container = $('#' + target);
    if (this.$container) {
      this.$links = this.$container.find('.accordion');
      this.$links.each(() => {
        $(this).on('click', (e) => {
          Accordion.click($(this));
        });
      });
    }

    return true;
  },
  click: ($el) => {
    this.hide();
    var href = $el.attr('href');
    var $target = $(href);
    if ($target.is(':visible')) {
      $target.hide();
    } else {
      $target.show();
    }
  },
  hide: () => {
    this.$links.each(() => {
      var href = $(this).attr('href');
      var $target = $(href);
      $($target).hide();
    });

    return true;
  }
};

$(() => {
  Accordion.init('accordion');
})

// module.exports = {
//   methods: Accordion.init
// };